import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#EF3A4A", // 원하는 primary 색상을 선택하십시오.
    },
    secondary: {
      main: "#55FF80", // 원하는 secondary 색상을 선택하십시오.
    },
    background: {
      default: "#ffffff", // 전체 배경 색상 변경
    },
  },
  typography: {
    fontFamily: [
      "Pretendard",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
});

export default theme;
